<div>
    <h6 class="ap-green mt-1">{{header1}}</h6>
    <div>
        <dx-data-grid #suspectsWithContactNamesGrid style="width: 100%" [dataSource]="suspectsWithContactNames" [columnAutoWidth]="true"N
            [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel  [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="dunsNumber" caption="DUNS Number" cssClass="column-group-sub-header">
            </dxi-column>
            <dxi-column dataField="companyName" caption="Company" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="address" caption="Address" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="city" caption="City" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="province" caption="State/Province" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="zipCode" caption="Postal Code" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="countryId" caption="Country" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="prefix" caption="Prefix" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="firstName" caption="First Name" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="middleName" caption="Middle Name" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="lastName" caption="Last Name" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="title" caption="Title" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siteID" caption="SiteID" cssClass="column-group-sub-header"></dxi-column>
        </dx-data-grid>
    </div>
</div>